import React, { useState, useEffect, useContext } from 'react';

import { Card, CardHeader, CardContent, Stack, TextField, FormHelperText } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';

import { db } from '../../../firebase';
import AlertsContext from '../../../AlertsContext';

const DEFAULT_AMOUNTS = [19, 38, 57, 76, 95, 114];
const settingsRef = doc(db, 'settings', 'giftCards');

// Parse comma-separated text into a list of positive numbers. Returns null if invalid.
export const parseAmounts = (text) => {
  const parts = text.split(',').map((p) => p.trim()).filter(Boolean);
  const nums = parts.map(Number);
  if (!nums.length || nums.some((n) => !Number.isFinite(n) || n <= 0)) return null;
  return nums;
};

export default function GiftCardsCard() {
  const { setAlert } = useContext(AlertsContext);
  const [value, setValue] = useState(DEFAULT_AMOUNTS.join(', '));
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return onSnapshot(settingsRef, (snap) => {
      const amounts = snap.data()?.amounts;
      if (Array.isArray(amounts) && amounts.length) setValue(amounts.join(', '));
    });
  }, []);

  const amounts = parseAmounts(value);

  const onSave = async () => {
    if (!amounts) return;
    try {
      setIsLoading(true);
      await setDoc(settingsRef, { amounts }, { merge: true });
      setAlert('Gift card amounts saved.');
    } catch (e) {
      setAlert({ type: 'error', message: 'Error.' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader title="Gift Card Amounts" />
      <CardContent>
        <Stack spacing={2}>
          <TextField
            label="Amounts (comma separated)"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          {!amounts && (
            <FormHelperText error>Enter positive numbers separated by commas.</FormHelperText>
          )}
          <LoadingButton
            disabled={!amounts}
            loading={isLoading}
            onClick={onSave}
            variant="contained"
          >
            Save
          </LoadingButton>
        </Stack>
      </CardContent>
    </Card>
  );
}
